import React, { Component } from 'react';
import {HandleSubmit} from '../../func/HandleSubmit';
import AddGroup from "../Group/AddGroup";
import DeleteObject from './DeleteGroup';
import GroupAccess from './GroupAccess';

class ListGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TableRow: [],
            Validation: {},
            Loading: true,
            TableOfObject: {}
        };
        this.GetTableOfObject = this.GetTableOfObject.bind(this);
    }
    async GetTableOfObject() {
        var response_info = await HandleSubmit('group/getlist', '');
        this.setState({
            TableOfObject: (response_info),
        });
        console.log("response_info", response_info);
    }
    async DeleteRow(item) {
        await DeleteObject(item);
        await this.InitList();
    }
    CreateRow() {
        let counter = 0;
        for (let item of this.state.TableOfObject) {
            this.state.TableRow.push({
                Row: <React.Fragment>
                    <td>{item.row}</td>
                    <td>{item.label}</td>
                    <td><button className="btn btn-outline-danger" onClick={() => (
                        this.DeleteRow(item.value)
                    )}>حذف </button></td>
                </React.Fragment>
            });
            counter++;
        }
        this.setState({
            TableRow: this.state.TableRow,
            //show_rem_row: this.state.show_rem_row
        });
    }
    async InitList() {
        this.setState({
            Loading: true,
            TableRow: [],

        });
        await this.GetTableOfObject();
        this.CreateRow();
        this.setState({
            Loading: false
        });
    }
    async componentDidMount() {
        this.InitList();
    }
    render() {
        if (this.state.Loading) { return "Loading..." }
        return (
            <div>
                <AddGroup initlist={() => this.InitList()} />
                <table className="table-responsive table-bordered table-striped" style={{ "textAlign": "center", "border": "4px solid rgba(0, 150, 255, 0.91)" }}>
                    <tbody>
                        <tr>
                            <th>#</th>
                            <th>نام گروه</th>
                        </tr>
                        {this.state.TableRow.map(
                            (item, index) => (
                                <React.Fragment key={index}>
                                    <tr>{item.Row}</tr>
                                </React.Fragment>
                            )
                        )}
                    </tbody>
                </table>
                {//<button className="btn btn-success" onClick={this.CheckValidation}>Valid</button>
                }
                <GroupAccess />

            </div >

        );
    }
}
export default (ListGroup);







// WEBPACK FOOTER //
// ./src/pages/Group/ListGroup.js